/* Aino chat cart attribution: match the exact recommended variant. */
(() => {
  'use strict';
  const key='disturb:aino:chat-variant:v1';
  const number=v=>String(v||'').match(/([0-9]+)$/)?.[1]||'';
  document.addEventListener('disturb:aino-size-recommended',event=>{
    const variantId=number(event.detail?.variantId);
    if(!variantId||event.detail?.path!==location.pathname)return;
    try{sessionStorage.setItem(key,JSON.stringify({variantId,path:location.pathname,at:Date.now()}));}catch{}
  });
  const original=window.fetch.bind(window);
  window.fetch=function(input,init){
    try{
      const url=new URL(typeof input==='string'?input:input.url,location.href);
      if(url.origin===location.origin && /\/cart\/add\.js$/.test(url.pathname) && typeof init?.body==='string'){
        const body=JSON.parse(init.body);
        const record=JSON.parse(sessionStorage.getItem(key)||'null');
        if(record && record.path===location.pathname && Date.now()-record.at<7200000 && Array.isArray(body.items)){
          for(const item of body.items){
            if(number(item.id)===record.variantId){
              item.properties={...item.properties,_aino_size_recommendation:'Kokosuositusta käytetty'};
            }
          }
          init={...init,body:JSON.stringify(body)};
        }
      }
    }catch{}
    return original(input,init);
  };
})();